import React from "react";


export const Plaid = (props) => {
    return (
        <div>
            <p>Coming soon!</p>
        </div>
    )
};